import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

export const CTABand = () => (
  <section data-testid="cta-band" className="relative py-20 border-y border-white/10 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-br from-ink-900 via-ink-950 to-ink-900" />
    <div className="absolute inset-0 grid-bg opacity-30" />
    <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-cyan-500/10 blur-3xl rounded-full" />

    <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-cyan-500/30 bg-cyan-500/10 mb-7">
        <ShieldCheck className="w-3.5 h-3.5 text-cyan-400" />
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-300">Tailored security · UK Wide</span>
      </div>
      <h2 className="font-display font-extrabold text-white text-3xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] mb-5">
        Ready to secure<br />
        <span className="text-gradient-cyan">your site today?</span>
      </h2>
      <p className="text-slate-400 text-lg max-w-2xl mx-auto mb-9">
        Speak with a UK consultant. We'll review your operational risks and propose a tailored security stack — within one working day.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Link to="/contact" data-testid="cta-band-primary" className="group inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-ink-950 font-bold rounded-md px-6 py-3.5 transition">
          Speak to a Consultant <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Link>
        <a href="tel:+448000494444" data-testid="cta-band-call" className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 bg-white/5 text-white font-medium rounded-md px-6 py-3.5 transition">
          Call 01268 947 077
        </a>
      </div>
    </div>
  </section>
);
